import React, { Component } from "react";
import image1 from "../img/Pres_1.png";
import image2 from "../img/Pres_2.png";
import image3 from "../img/Pres_3.jpg";

class Presentation extends Component {
  render() {
    return (
      <div className="container presentation">
        <div className="row">
          <div className="col-8 blockquote text">
            <p>
              Tout a commencé le 10 juin 1948, quand Charles Herré décide de se
              mettre à son compte et s'installe à Vendenheim. Secondé par son
              épouse Irène, il s'installe au 33 rue du général Leclerc dans la
              maison de Joseph Kuntz. L'affaire prospère, le local devient trop
              exigu. Ainsi en 1960, la boutique et l'atelier déménagent dans
              l’ancienne Coop au 24 rue du général Leclerc, l’emplacement
              actuel. Une simple fenêtre fait alors office de vitrine.
            </p>
            <p>
              Guido Herré a 17 ans en 1967. Après le lycée, il se destine à des
              études de chirugien-dentiste. Mais son père le persuade de
              bifurquer vers le métier d'horloger. Il entre alors en
              apprentissage à la maison Kirrmann à Strasbourg et fait un brevet
              de compagnon en horlogerie avec quelques stages à la clé en
              Suisse. A 21 ans, le brevet de compagnon en poche, il part faire
              son service militaire pendant un an. Nous sommes alors en février
              1972 et Guido travaille maintenant à son propre compte dans la
              boutique de son père. 15 ans plus tard, le 1er juillet 1987,
              Charles prend sa retraite et Guido devient seul maitre à bord dans
              la bijouterie familiale. Seul ? pas vraiment... puisqu'il est
              secondé par sa femme Eliane.
            </p>
            <p>
              C'est en 1996 que Marion, 18 ans, s'associera à eux. Après ses
              études elle travaille en alternance durant deux ans dans la
              boutique de son père. Elle sera ensuite salariée, co-gérante en
              avril 2007 et enfin gérante en 2020.
            </p>
            <p>
              Pour préparer le départ à la retraite de ses parents, c'est Louis
              Gauss qui arrivé en stage en 2014 prend la relève de Guido à
              l'atelier. Il n'y a plus beaucoup de réparateurs en pendulerie
              ancienne et l'offre dans ce secteur se fait rare. Peu de magasins
              de vente ont encore un atelier constatent l'expert de la famille.
              C'est pourquoi le bijoutier-horloger a embauché en CDI Louis en
              2015, pour pérenniser ce service dans son magasin. Originaire du
              Haut-Rhin, Louis a suivi une formation d'horloger à Nantes avant
              de venir s'installer à Strasbourg. A Vendenheim, il exerce le
              métier avec toute la minutie et l'exigence qui conviennent.
            </p>
            <p>
              Atelier de réparation en horlogerie, mais aussi de création et de
              transformation de bijoux. Maison fondée le 10 juin 1948, la
              Bijouterie-Horlogerie Herré a fêté ses 72 printemps. Marion Herré
              incarne la troisième génération de bijoutiers-joailliers fédinois.
              Ses parents Guido et Eliane racontent la vie de leur entreprise
              familiale où la transmission se fait de manière naturelle, par
              l'envie !
            </p>
          </div>
          <div className="col images">
            <img
              src={image1}
              className="card-img-top"
              alt="Charles Herré"
              title="my-img"
            />
            <img
              src={image2}
              className="card-img-top"
              alt="Guido, Marion, Eliane"
            />
            <img
              src={image3}
              className="card-img-top"
              alt="Guido, Eliane, Marion"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Presentation;
